import { createRouter, createWebHistory } from 'vue-router'
import Bazi from './views/BaZi.vue'
import ShopRecords from './views/ShopRecords.vue'
const routes = [
  {
    path: '/',
    name: 'bazi',
    component: Bazi
  },
  {
    path: '/b',
    name: 'ShopRecords',
    component: ShopRecords
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router